export default __webpack_public_path__ + "static/media/sub_banner_2.43ef3da4.jpg";